module.exports = __webpack_public_path__ + "static/discount3-7fc9b57e07a398b4905a864ac6a517a9.jpg";